import { Type } from 'class-transformer';
import { AnnouncementRawDto } from './announcement-raw-dto';
import { KeyValueResultDto } from './key-value-result-dto';

export class AnnouncementEditorResultDto {
    @Type(() => AnnouncementRawDto)
    announcementData: AnnouncementRawDto;

    @Type(() => KeyValueResultDto)
    audiences: KeyValueResultDto[];

    allowLocationAnnouncements: boolean;
    allowManagementCompanyAnnouncements: boolean;
    allowGlobalAnnouncements: boolean;
}
